import styled from 'styled-components';

const Subtitle = styled.p`
  text-align: center;
  font-weight: 300;
  font-size: var(--font-size-m);
  color: #1e1e1e;
  line-height: 1.25em;
`;

export default Subtitle;
